import React from 'react';
import LandingContainer from '../LandingContainer';
import {
  BASE_SUBMISSION_RATE,
  formatCents,
  FREE_ENDPOINT_ALLOWANCE,
  FREE_SUBMISSION_ALLOWANCE,
} from '../../../utils/pricingCalculator';

const ROWS = [
  ['Free submissions', `${FREE_SUBMISSION_ALLOWANCE} a month, then ${formatCents(BASE_SUBMISSION_RATE)} each`, 'Often a smaller monthly cap'],
  ['Forms', `${FREE_ENDPOINT_ALLOWANCE} included, then paid blocks`, 'Often a low cap, or unlimited with other limits'],
  ['File uploads', 'Included, up to 10 MB per file', 'Often reserved for a paid plan'],
  ['History', 'Kept in your inbox', 'Often deleted after a short window'],
  ['After the free allowance', `${formatCents(BASE_SUBMISSION_RATE)} per extra submission`, 'Often a monthly subscription'],
  ['Your HTML', 'Unchanged. One action URL.', 'Sometimes a script or a hosted form builder'],
];

export default function CompareSection() {
  return (
    <section id="compare" className="scroll-mt-20 bg-neutral-50 py-10 sm:py-16">
      <LandingContainer>
        <h2 className="max-w-2xl font-heading text-2xl font-bold leading-tight tracking-tight text-charcoal-900 sm:text-3xl">
          How FormCare compares
        </h2>
        <p className="mt-3 max-w-2xl text-sm leading-6 text-charcoal-600">
          A general look at other hosted form backends. Plans differ, so the notes describe what is common, not every service.
        </p>
        <ul className="mt-6 grid gap-3 sm:hidden">
          {ROWS.map(([label, ours, theirs]) => (
            <li key={label} className="rounded-2xl border border-neutral-200 bg-white p-4">
              <p className="font-semibold text-charcoal-900">{label}</p>
              <p className="mt-2 text-sm leading-6 text-charcoal-700">
                <span className="font-medium text-charcoal-900">FormCare. </span>
                {ours}
              </p>
              <p className="mt-1 text-sm leading-6 text-charcoal-600">
                <span className="font-medium text-charcoal-900">Other services. </span>
                {theirs}
              </p>
            </li>
          ))}
        </ul>
        <div className="mt-6 hidden overflow-hidden rounded-2xl border border-neutral-200 bg-white sm:block">
          <table className="w-full text-left text-sm">
            <thead className="bg-neutral-50 text-charcoal-700">
              <tr>
                <th className="px-4 py-3 font-semibold"> </th>
                <th className="px-4 py-3 font-semibold">FormCare</th>
                <th className="px-4 py-3 font-semibold">Other services</th>
              </tr>
            </thead>
            <tbody>
              {ROWS.map(([label, ours, theirs]) => (
                <tr key={label} className="border-t border-neutral-200">
                  <th className="px-4 py-3 font-medium text-charcoal-900">{label}</th>
                  <td className="px-4 py-3 text-charcoal-700">{ours}</td>
                  <td className="px-4 py-3 text-charcoal-600">{theirs}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </LandingContainer>
    </section>
  );
}
